export var SENTRY_RELEASE = "4a648122dda91c9367690c319570a274f112e599";
